const ImportEmployeeStatus =
{
    Pendente: 0,
    Processando: 1,
    Concluido: 2,
    Falha: 3
}
export default ImportEmployeeStatus;